import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthPageLayout from "./AuthPageLayout";
import { Helmet } from "react-helmet";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!email) {
    toast.error("Please enter your email address.");
    return;
  }

  setLoading(true);
  try {
    const response = await axios.get(`https://api.shipperswise.com/reset-password/${email}`);
    const message = response.data.message;

    if (message?.toLowerCase() === "recovery email sent.") {
      toast.success(message); // use the exact message from the server
    } else {
      toast.error(message || "An unexpected response from the server.");
    }
  } catch (err) {
    const apiError = err.response?.data?.message || "An error occurred. Please try again.";
    toast.error(apiError);
  } finally {
    setLoading(false);
  }
};



  return (
    <>
      <Helmet>
        <title>Forgot Password</title>
      </Helmet>
      <AuthPageLayout>
        <ToastContainer />
        <div className="login-form">
          <h1 className="mb-3 text-center login-text">Forgot Password</h1>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button type="submit" className="btn btn-primary w-100 mb-3" disabled={loading}>
              {loading ? "Sending..." : "Send recovery mail"}
            </button>

            <p className="text-center mt-3">
              <Link to="/login" className="create-account">
                Back to Login
              </Link>
            </p>
          </form>
        </div>
      </AuthPageLayout>
    </>
  );
}
